<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Data Table" pageTitle="Data Table" />
            <DataTable />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import DataTable from '../DataTable/DataTable'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'DataTablePage',
    components: {
        MainHeader,
        PageTitle,
        DataTable,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>